(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ---------- utils ---------- */
  const money = (cents) => {
    const fmt = window.Diara?.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    let [int, dec] = amount.split('.');
    if (dec === '00') dec = '';
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const whole = String(Math.round(cents / 100)); // no-decimals formats round like Liquid's money filters (₹1,487.50 → ₹1,488)
    return fmt
      .replace('{{amount}}', dec ? `${withCommas}.${dec}` : withCommas)
      .replace('{{amount_no_decimals}}', whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_with_comma_separator}}', dec ? `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}` : int.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_no_decimals_with_comma_separator}}', whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  };
  window.Diara = Object.assign(window.Diara || {}, { money });

  const toast = (msg) => {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };
  window.Diara.toast = toast;

  /* ---------- drawers ---------- */
  const drawers = {
    open(id) {
      const d = document.getElementById(id); if (!d) return;
      d.removeAttribute('hidden'); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      const focusable = $('input, button, a', d.querySelector('.drawer__panel'));
      setTimeout(() => focusable && focusable.focus(), 350);
      d._trigger = document.activeElement;
    },
    close(d) {
      if (typeof d === 'string') d = document.getElementById(d);
      if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      if (!$$('.drawer.is-open').length) document.body.classList.remove('drawer-open');
      d._trigger && d._trigger.focus && d._trigger.focus();
    },
  };
  window.Diara.drawers = drawers;
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); drawers.open(openBtn.dataset.drawerOpen); return; }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { e.preventDefault(); drawers.close(closeBtn.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(drawers.close); });

  /* ---------- header ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    const ann = $('.announcement');
    const setAnn = () => document.documentElement.style.setProperty('--announcement-height', `${ann && !ann.classList.contains('is-hidden') ? ann.offsetHeight : 0}px`);
    setAnn(); window.addEventListener('resize', setAnn);
    $('.announcement__close')?.addEventListener('click', () => { ann.classList.add('is-hidden'); try { sessionStorage.setItem('diara-ann', '1'); } catch (_) {} setAnn(); });
    try { if (sessionStorage.getItem('diara-ann')) { ann?.classList.add('is-hidden'); setAnn(); } } catch (_) {}
  }

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { threshold: 0.12 });
  $$('.reveal').forEach((el) => io.observe(el));

  /* ---------- cart ---------- */
  const cart = {
    async request(url, body) {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Something went wrong');
      return json;
    },
    async refresh(openDrawer) {
      const res = await fetch(`${window.Diara.routes.cart_url}?section_id=cart-drawer`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      const current = $('#CartDrawer');
      if (fresh && current) {
        const wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) current.classList.add('is-open');
      }
      const count = doc.querySelector('[data-cart-count]')?.dataset.cartCount ?? '0';
      $$('[data-cart-count]').forEach((el) => { el.dataset.cartCount = count; el.textContent = count; });
      if (openDrawer && $('#CartDrawer')) drawers.open('CartDrawer');
    },
    async add(form, button) {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      const original = button.innerHTML;
      button.setAttribute('aria-disabled', 'true');
      button.querySelector('[data-add-label]') ? (button.querySelector('[data-add-label]').textContent = window.Diara.strings.adding) : (button.textContent = window.Diara.strings.adding);
      try {
        const res = await fetch(`${window.Diara.routes.cart_add_url}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message);
        await cart.refresh(window.Diara.cartDrawer);
        if (!window.Diara.cartDrawer) toast(window.Diara.strings.added);
      } catch (err) { toast(err.message); }
      finally { button.innerHTML = original; button.removeAttribute('aria-disabled'); }
    },
    async change(key, quantity) {
      try { await cart.request(`${window.Diara.routes.cart_change_url}.js`, { id: key, quantity }); await cart.refresh(false); if ($('.main-cart')) window.location.reload(); }
      catch (err) { toast(err.message); }
    },
  };
  window.Diara.cart = cart;
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    cart.add(form, form.querySelector('[type=submit]'));
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); cart.change(rm.dataset.cartRemove, 0); return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const wrap = q.closest('.qty'); const input = wrap.querySelector('input');
      const next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(q.dataset.qtyChange, 10));
      input.value = next;
      if (wrap.dataset.lineKey) cart.change(wrap.dataset.lineKey, next);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty input');
    if (input && input.closest('.qty').dataset.lineKey) cart.change(input.closest('.qty').dataset.lineKey, Math.max(0, parseInt(input.value || '0', 10)));
  });

  /* ---------- product form / variants ---------- */
  class ProductForm {
    constructor(el) {
      this.el = el;
      this.variants = JSON.parse($('[data-variants]', el).textContent);
      this.forms = $$('form[action*="/cart/add"]', el);
      this.form = this.forms[0];
      this.idInput = $('input[name="id"]', this.form);
      el.addEventListener('change', (e) => {
        const t = e.target;
        if (!t.matches('.variant-picker input, .variant-picker select')) return;
        // mirror the choice into every other picker (size tiles <-> sticky-bar select)
        $$(`.variant-picker [name="${CSS.escape(t.name)}"]`, el).forEach((x) => {
          if (x === t) return;
          if (x.type === 'radio') x.checked = x.value === t.value; else x.value = t.value;
        });
        this.onChange();
      });
      this.onChange(false);
    }
    selected() {
      const root = $('.variant-picker[data-primary-picker]', this.el) || $('.variant-picker', this.el);
      if (!root) return [];
      const groups = root.matches('fieldset') ? [root] : $$('fieldset, .select', root);
      return groups.map((f) => {
        const checked = f.querySelector('input:checked'); if (checked) return checked.value;
        const sel = f.querySelector('select'); return sel ? sel.value : null;
      });
    }
    onChange(updateUrl = true) {
      const opts = this.selected();
      let v;
      if (opts.length) v = this.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      else v = this.variants.find((x) => String(x.id) === String(this.idInput?.value)) || this.variants[0];
      $$('.variant-picker legend span', this.el).forEach((sp) => { sp.textContent = opts[0] || ''; });
      const buttons = this.forms.map((f) => $('[type=submit]', f)).filter(Boolean);
      if (!v) { buttons.forEach((b) => { b.setAttribute('disabled', ''); $('[data-add-label]', b).textContent = window.Diara.strings.unavailable; }); return; }
      this.forms.forEach((f) => { const i = $('input[name="id"]', f); if (i) i.value = v.id; });
      const stickyTitle = $('[data-sticky-variant]', this.el);
      if (stickyTitle) stickyTitle.textContent = v.title === 'Default Title' ? '' : v.title;
      $$('[data-price]', this.el).forEach((el) => { el.textContent = money(v.price); });
      $$('[data-offer-price]', this.el).forEach((el) => { const pct = Number(el.dataset.offerPct) || 0; el.textContent = money(Math.round(v.price * (100 - pct) / 100)); });
      $$('[data-compare-price]', this.el).forEach((el) => { if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; } else el.hidden = true; });
      const mrpOn = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-mrp-wrap]', this.el).forEach((el) => { el.hidden = !mrpOn; });
      $$('[data-compare-price]', this.el).forEach((el) => { if (el.closest('[data-mrp-wrap]')) el.hidden = false; });
      $$('[data-mrp-off]', this.el).forEach((el) => { const pay = el.dataset.offPct ? Math.round(v.price * (100 - Number(el.dataset.offPct)) / 100) : v.price; const on = v.compare_at_price && v.compare_at_price > pay; el.hidden = !on; if (on) el.textContent = (el.dataset.tpl || el.textContent).replace(/\d+%/, Math.floor((v.compare_at_price - pay) * 100 / v.compare_at_price) + '%'); });
      buttons.forEach((b) => {
        const label = $('[data-add-label]', b);
        if (v.available) {
          b.removeAttribute('disabled');
          const inline = b.closest('[data-inline-form]');
          label.textContent = window.Diara.strings.addToCart + (inline && v.title !== 'Default Title' ? ` · ${v.title}` : '');
        } else { b.setAttribute('disabled', ''); label.textContent = b.dataset.soon || window.Diara.strings.soldOut; }
        $$('[data-offer-price], [data-price]', b).forEach((el) => { el.hidden = !v.available; });
      });
      if (v.featured_media && window.Diara.mediaSwitch) window.Diara.mediaSwitch(v.featured_media.id, updateUrl);  // updateUrl is false only on the initial sync
      if (updateUrl && history.replaceState) { const u = new URL(location); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
  }
  $$('[data-product-form]').forEach((el) => new ProductForm(el));

  /* ---------- carousels ---------- */
  $$('[data-carousel]').forEach((root) => {
    const track = $('.carousel', root) || root;
    const prev = $('[data-prev]', root), next = $('[data-next]', root);
    const dots = $$('.dots button', root);
    const slides = [...track.children];
    const go = (i) => { const s = slides[Math.max(0, Math.min(i, slides.length - 1))]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
    const index = () => Math.round(track.scrollLeft / (slides[0]?.offsetWidth + parseFloat(getComputedStyle(track).gap || 0)));
    prev?.addEventListener('click', () => go(index() - 1));
    next?.addEventListener('click', () => go(index() + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    const update = () => {
      const i = index();
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i));
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    track.addEventListener('scroll', update, { passive: true }); update();
    if (root.dataset.autoplay) {
      let t = setInterval(() => go((index() + 1) % slides.length), parseInt(root.dataset.autoplay, 10));
      root.addEventListener('pointerenter', () => clearInterval(t));
      root.addEventListener('pointerleave', () => { t = setInterval(() => go((index() + 1) % slides.length), parseInt(root.dataset.autoplay, 10)); });
    }
  });

  /* ---------- product card media carousels (swipe / drag through a product's images on the card) ---------- */
  $$('[data-card-media]').forEach((root) => {
    const track = $('[data-card-track]', root); if (!track) return;
    const slides = $$('.card-media__slide', track); if (slides.length < 2) return;
    const dots = $$('.card-media__dots span', root);
    const w = () => track.clientWidth || 1;
    const clamp = (i) => Math.max(0, Math.min(slides.length - 1, i));
    const index = () => clamp(Math.round(track.scrollLeft / w()));
    const go = (i) => track.scrollTo({ left: clamp(i) * w(), behavior: 'smooth' });
    let st; track.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => { const i = index(); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); }, 60); }, { passive: true });
    $$('.card-media__arrow', root).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(index() + (b.dataset.dir === 'next' ? 1 : -1)); }));
    let x0 = null, lastX = null, left0 = 0, dragged = false;
    track.addEventListener('dragstart', (e) => e.preventDefault());
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; x0 = lastX = e.clientX; left0 = track.scrollLeft; dragged = false; });
    track.addEventListener('pointermove', (e) => { if (x0 === null) return; lastX = e.clientX; const dx = e.clientX - x0; if (!dragged && Math.abs(dx) > 6) { dragged = true; track.classList.add('is-dragging'); } if (dragged) track.scrollLeft = left0 - dx; });
    const end = () => { if (x0 === null) return; const dx = lastX - x0, start = Math.round(left0 / w()); x0 = null; if (!dragged) return; track.classList.remove('is-dragging'); requestAnimationFrame(() => go(dx < -40 ? start + 1 : dx > 40 ? start - 1 : start)); };
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((n) => track.addEventListener(n, end));
    track.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
  });

  /* ---------- product card flame loops (2026-10-13): the card nearest the centre of the screen plays its muted loop, one at a time; hover plays on desktop; off for reduced motion / data saver / 2G ---------- */
  (() => {
    const vids = $$('[data-card-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    const conn = navigator.connection || {};
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData || /2g/.test(conn.effectiveType || '')) return;
    const visible = new Set(); let current = null, hovered = null, raf = 0;
    const stop = (v) => { v.classList.remove('is-playing'); v.pause(); };
    const start = (v) => { if (!v.getAttribute('src')) v.src = v.dataset.src; const p = v.play(); if (p && p.then) p.then(() => { if (v === current) v.classList.add('is-playing'); }).catch(() => {}); };
    const pick = () => {
      raf = 0;
      let best = hovered && visible.has(hovered) ? hovered : null, bestD = Infinity;
      if (!best) {
        const cx = innerWidth / 2, cy = innerHeight / 2;
        visible.forEach((v) => { const r = v.getBoundingClientRect(); if (!r.width) return; const d = Math.hypot(r.left + r.width / 2 - cx, r.top + r.height / 2 - cy); if (d < bestD) { bestD = d; best = v; } });
      }
      if (best !== current) { if (current) stop(current); current = best; if (current) start(current); }
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(pick); };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.intersectionRatio >= 0.6) visible.add(e.target); else { visible.delete(e.target); if (e.target === current) { stop(current); current = null; } } });
      schedule();
    }, { threshold: [0, 0.6, 1] });
    const canHover = window.matchMedia('(hover: hover)').matches;
    vids.forEach((v) => {
      io.observe(v);
      const card = v.closest('.product-card');
      if (card && canHover) {
        card.addEventListener('mouseenter', () => { hovered = v; schedule(); });
        card.addEventListener('mouseleave', () => { if (hovered === v) hovered = null; schedule(); });
      }
    });
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) { if (current) stop(current); current = null; } else schedule(); });
  })();

  /* ---------- video toggles ---------- */
  $$('[data-video-toggle]').forEach((btn) => {
    const v = document.getElementById(btn.dataset.videoToggle);
    btn.addEventListener('click', () => { if (v.paused) { v.play(); btn.dataset.state = 'playing'; } else { v.pause(); btn.dataset.state = 'paused'; } });
  });

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', (e) => { $$('.reveal', e.target).forEach((el) => el.classList.add('is-visible')); });
})();
